import ApiService from "../api.services";

const PdvService = {
  call: async function () {
    try {
      const response = await ApiService.get(`/api/pdv/call`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  reversal: async function (id) {
    try {
      const response = await ApiService.delete(`/api/pdv/call/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  save: async function (data) {
    try {
      const response = await ApiService.post(`/api/pdv/call`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  proof: async function (id, key, by) {
    try {
      const response = await ApiService.get(
        `/api/pdv/proof?call=${id}&key=${key}&createdBy=${by}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  labels: async function (id, key, by) {
    try {
      const response = await ApiService.get(
        `/api/pdv/labels?call=${id}&key=${key}&createdBy=${by}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  pendencies: async function (customer) {
    try {
      const response = await ApiService.get(
        `/api/pdv/pendencies?customer=${customer}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  authorization: async function (
    customer,
    authorization,
    tag,
    startedAt,
    finishedAt,
    id,
    action,
    type
  ) {
    try {
      console.log("chamou aqui", action);
      const response = await ApiService.get(
        `/api/pdv/authorization?customer=${customer}&authorization=${authorization}&tag=${tag}&startedAt=${startedAt}&finishedAt=${finishedAt}&id=${id}&action=${action}&type=${type}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  down: async function (data) {
    try {
      const response = await ApiService.post(`/api/pdv/pendencies`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (tag) {
    try {
      const response = await ApiService.delete(`/api/pdv/call/tag/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  external: async function (data) {
    try {
      const response = await ApiService.post(
        `/api/pdv/call/external/list`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PdvService;

export { PdvService };
